module.exports = function(data) {
var __t, __p = '';
__p += '<form id="merchant-forcePassChange-form">\n    <div class="alert-danger">\n        Hi, your password has expired.<br/>Please update it now.\n    </div>\n    <div id="login-status" class="alert alert-danger hidden" role="alert"></div>\n\n    <div class="form-group new-password"></div>\n    <div class="submit-btn-block">\n        <button class="btn btn-lg btn-primary btn-last-step change-password" disabled="true">' +
((__t = ( strings.login.saveNewPassword )) == null ? '' : __t) +
'</button>\n    </div>\n</form>\n';
return __p
}